<script>
import DataProvider from './DataProvider.vue';
import MemberRepository from '../../js/repository/MemberRepository';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
        callback: {
            type: Function,
            required: false,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: MemberRepository.findLegalRepresentativesAndRelations,
                params: [this.memberId],
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
